import { Product } from '../types/product-variant';
import { useLocale } from '../context/LocaleContext';

interface EnhancedProductSchemaProps {
  product: Product;
  currentUrl: string;
  images?: string[];
}

const EnhancedProductSchema: React.FC<EnhancedProductSchemaProps> = ({ product, currentUrl, images }) => {
  const { locale } = useLocale();

  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": (images || []).filter(Boolean),
    "url": currentUrl,
    "inLanguage": locale,
    "sku": product.id,
    "brand": {
      "@type": "Brand",
      "name": "Camila Parente"
    },
    "offers": {
      "@type": "Offer",
      "url": currentUrl,
      "priceCurrency": "EUR",
      "price": product.variants?.length ? Math.min(...product.variants.map(v => v.price)) : product.price,
      "itemCondition": "https://schema.org/NewCondition",
      "availability": product.inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
    },
    // Additional Meta catalog specific properties
    "productID": product.id,
    "category": product.category,
    "material": product.material,
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "collection",
        "value": product.collection
      },
      {
        "@type": "PropertyValue",
        "name": "oneOfKind",
        "value": product.oneOfKind || false
      }
    ]
  };

  return (
    <>
      <meta property="product:brand" content="Camila Parente" />
      <meta property="product:availability" content={product.inStock ? "in stock" : "out of stock"} />
      <meta property="product:condition" content="new" />
      <meta property="product:price:amount" content={String(product.variants?.length ? Math.min(...product.variants.map(v => v.price)) : product.price)} />
      <meta property="product:price:currency" content="EUR" />
      <meta property="product:retailer_item_id" content={product.id} />
      <meta property="product:category" content={product.category} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
};

export default EnhancedProductSchema; 